export class AllocationApprovalReq {
  sampleRequestId: number;
  sampleRequestItemId:number;
  action: string;
  updateStatus: boolean;

}
